import { MIME_TYPES, MOODLE_STRINGS, TIPDDY_MODULES } from "./state";

export function normalizer(data, course_id = null) {
  let programModules = [];
  let onlineModules = [];
  let diagnostic = null;
  let normalizeModules = data;
  let schedule = [];

  const hasContents = (resource) => resource?.contents && resource.contents.length > 0;
  const getFirstContent = (resource) => hasContents(resource) ? resource.contents[0] : null;

  /**
   * @function loop
   * Receive the modules and for each module find the [resources]
   *
   */
  console.log('normalizer', data)
  for (let module of normalizeModules) {
    module.modules = module.modules.filter(
      (r) => r.modname !== TIPDDY_MODULES.label
    );
    /**
     *
     * @function loop
     * For each resource normalize its type for the app
     *
     */

    module = getRawProgress(module);

    for (let resource of module.modules) {
      let newresource = resource;
      newresource.tipddyname = resource.modname;

      /**
       * Option for resource with no tracking feature set to default as completed
       */
      if (newresource.completion === 0) {
        newresource.isTracked = false;
        newresource.isCompleted = true;
      }

      /**
       * For any king of completion config set tracking feature to true
       */
      if (newresource.completion !== 0 && newresource.completiondata) {
        newresource.isTracked = true;
        /**
         * Verify for any kind of config the completion status
         */
        if (newresource.completiondata.state !== 0) {
          newresource.isCompleted = true;
        }
        /**
         * Incomplete status
         */
        if (newresource.completiondata.state === 0) {
          newresource.isCompleted = false;
        }
      }

      /**
       *
       * @type { FORUM }
       * Forum type for the moment just set the prop tipddyname as standard
       *
       */
      if (newresource.modname === TIPDDY_MODULES.forum) {
        newresource.tipddyname = TIPDDY_MODULES.forum;
      }
      /**
       *
       * @type { CHOICE }
       *
       */
      if (newresource.modname === TIPDDY_MODULES.choice) {
        newresource.tipddyname = TIPDDY_MODULES.choice;
      }
      /**
       *
       * @type { URL }
       *
       */
      if (newresource.modname === TIPDDY_MODULES.url) {
        newresource.tipddyname = TIPDDY_MODULES.url;
      }

      if (resource.name === TIPDDY_MODULES.diagnostic) {
        diagnostic = [resource];
      }
      /**
       *
       * @type { URL:HUMHUB }
       *
       */
      if (
        newresource.modname === TIPDDY_MODULES.url &&
        newresource.name.toLowerCase().includes("humhub")
      ) {
        newresource.tipddyname = TIPDDY_MODULES.humhub;

        let humhub_data = getFirstContent(newresource)?.fileurl?.split("/");
        if (humhub_data && humhub_data.length >= 4) {
          newresource.humhub_url = humhub_data[2];
          newresource.humhub_ws = humhub_data[3];
        }
      }
      /**
       *
       * @type { URL:VIMEO }
       *
       */
      if (
        newresource.modname === TIPDDY_MODULES.url &&
        getFirstContent(newresource)?.fileurl.includes("vimeo")
      ) {
        newresource.tipddyname = TIPDDY_MODULES.vimeo;

        let vimeodata = getFirstContent(newresource)?.fileurl?.split("/");
        if (vimeodata) {
          newresource.video_id = vimeodata[vimeodata.length - 1];

          if (vimeodata.length > 4) {
            newresource.video_h = vimeodata[vimeodata.length - 1];
            newresource.video_id = vimeodata[vimeodata.length - 2];
          }
        }
      }
      /**
       *
       * @type { URL:ZOOM }
       *
       */
      if (
        newresource.modname === TIPDDY_MODULES.url &&
        getFirstContent(newresource)?.fileurl.includes("zoom")
      ) {
        newresource.tipddyname = TIPDDY_MODULES.zoom;
        newresource.onlineurl = getFirstContent(newresource)?.fileurl;
        newresource.tipddytype = MOODLE_STRINGS.ONLINE;

        onlineModules = [...onlineModules, newresource];
      }
      /**
       * Recurso
       * @type { MODNAME:ZOOM }
       *
       */
      if (newresource.modname === TIPDDY_MODULES.zoom) {
        newresource.tipddyname = TIPDDY_MODULES.zoom;
        newresource.tipddytype = MOODLE_STRINGS.ONLINE;
        newresource.embed = true;

        onlineModules = [...onlineModules, newresource];
      }
      /**
       *
       * @type { URL:TEAMS }
       *
       */
      if (
        newresource.modname === TIPDDY_MODULES.url &&
        getFirstContent(newresource)?.fileurl.includes("teams")
      ) {
        newresource.tipddyname = TIPDDY_MODULES.teams;
        newresource.onlineurl = getFirstContent(newresource)?.fileurl;
        newresource.tipddytype = MOODLE_STRINGS.ONLINE;

        onlineModules = [...onlineModules, newresource];
      }
      /**
       *
       * @type { URL:MEET }
       *
       */
      if (
        newresource.modname === TIPDDY_MODULES.url &&
        getFirstContent(newresource)?.fileurl.includes("meet.google")
      ) {
        newresource.tipddyname = TIPDDY_MODULES.meet;
        newresource.onlineurl = getFirstContent(newresource)?.fileurl;
        newresource.tipddytype = MOODLE_STRINGS.ONLINE;

        onlineModules = [...onlineModules, newresource];
      }

      /**
       *
       * @type { STORAGE }
       *|
       */
      if (newresource.modname === TIPDDY_MODULES.data) {
        newresource.tipddyname = TIPDDY_MODULES.data;
      }
      /**
       *
       * @type { CERT }
       *
       */
      if (newresource.modname === TIPDDY_MODULES.customcert) {
        newresource.tipddyname = TIPDDY_MODULES.customcert;
      }
      /**
       *
       * @type { PDF }
       * For the PDF type se the tipddyname , pass the file to direct handling and mimetype
       *
       */
      if (
        newresource.modname === TIPDDY_MODULES.resource &&
        hasContents(newresource) &&
        newresource.contents[0].mimetype === MIME_TYPES.pdf
      ) {
        newresource.tipddyname = TIPDDY_MODULES.pdf;
        newresource.tipddyurl = getFirstContent(newresource)?.fileurl?.split("?")[0];
        newresource.tipddymimetype = newresource.contents[0].mimetype;
      }
      /**
       *
       * @type { IMAGE/PNG }
       * For the PDF type se the tipddyname , pass the file to direct handling and mimetype
       *
       */
      if (
        newresource.modname === TIPDDY_MODULES.resource &&
        hasContents(newresource) &&
        newresource.contents[0].mimetype === MIME_TYPES.png
      ) {
        newresource.tipddyname = TIPDDY_MODULES.png;
        newresource.tipddyurl = getFirstContent(newresource)?.fileurl?.split("?")[0];
        newresource.tipddymimetype = newresource.contents[0].mimetype;
      }
      /**
       *
       * @type { QUIZ }
       * Quiz time handle dates if necesary
       *
       */
      if (newresource.modname === TIPDDY_MODULES.quiz) {
        newresource.tipddyname = TIPDDY_MODULES.quiz;
        /**
         *
         * Verify if has Dates for the open and close Assignment
         *
         */
        if (newresource.dates.length > 0) {
          let open = newresource.dates.find(
            (d) => d.dataid === MOODLE_STRINGS.TIMEOPEN
          );
          let close = newresource.dates.find(
            (d) => d.dataid === MOODLE_STRINGS.TIMECLOSE
          );

          /**
           *
           * With the dates check for the active or inactive status
           *
           */
          if (open && close) {
            let today = new Date();
            let openDate = new Date(open.timestamp * 1000);
            let closeDate = new Date(close.timestamp * 1000);

            let isClose = closeDate < today;
            let isOpen = openDate < today && !isClose;

            newresource.isopen = isOpen;
            newresource.isclose = isClose;
            newresource.tipddyopen = open.timestamp;
            newresource.tipddyclose = close.timestamp;
          }
        }
      }

      /**
       *
       * @type { FEEDBACK }
       * Feedback and handling dates if necesary
       *
       */
      if (newresource.modname === TIPDDY_MODULES.feedback) {
        newresource.tipddyname = TIPDDY_MODULES.feedback;

        if (newresource.dates.length > 0) {
          let open = newresource.dates.find(
            (d) => d.dataid === MOODLE_STRINGS.TIMEOPEN
          );
          let close = newresource.dates.find(
            (d) => d.dataid === MOODLE_STRINGS.TIMECLOSE
          );

          /**
           *
           * With the dates check for the active or inactive status
           *
           */
          if (open && close) {
            let today = new Date();
            let openDate = new Date(open.timestamp * 1000);
            let closeDate = new Date(close.timestamp * 1000);

            let isClose = closeDate < today;
            let isOpen = openDate < today && !isClose;

            newresource.isopen = isOpen;
            newresource.isclose = isClose;
            newresource.tipddyopen = open.timestamp;
            newresource.tipddyclose = close.timestamp;
          }
        }
      }
      /**
       *
       * @type { SCORM }
       * Feedback and handling dates if necesary
       *
       */
      if (newresource.modname === TIPDDY_MODULES.scorm) {
        newresource.tipddyname = TIPDDY_MODULES.scorm;
      }
      /**
       *
       * @type { ASSIGN }
       * Feedback and handling dates if necesary
       *
       */
      if (newresource.modname === TIPDDY_MODULES.assign) {
        newresource.tipddyname = TIPDDY_MODULES.assign;

        if (newresource.dates.length > 0) {
          let open = newresource.dates.find(
            (d) => d.dataid === MOODLE_STRINGS.TIMEOPEN
          );
          let close = newresource.dates.find(
            (d) => d.dataid === MOODLE_STRINGS.TIMECLOSE
          );

          /**
           *
           * With the dates check for the active or inactive status
           *
           */
          if (open && close) {
            let today = new Date();
            let openDate = new Date(open.timestamp * 1000);
            let closeDate = new Date(close.timestamp * 1000);

            let isClose = closeDate < today;
            let isOpen = openDate < today && !isClose;

            newresource.isopen = isOpen;
            newresource.isclose = isClose;
            newresource.tipddyopen = open.timestamp;
            newresource.tipddyclose = close.timestamp;
          }
        }
      }
      /**
       *
       * @type { FOLDER }
       * Feedback and handling dates if necesary
       *
       */
      if (newresource.modname === TIPDDY_MODULES.folder) {
        newresource.tipddyname = TIPDDY_MODULES.folder;
      }

      /**
       *
       * @type { CHAT }
       * Feedback and handling dates if necesary
       *
       */
      if (newresource.modname === TIPDDY_MODULES.chat) {
        newresource.tipddyname = TIPDDY_MODULES.chat;
      }
      /**
       *
       * @type { PAGE }
       * Feedback and handling dates if necesary
       *
       */
      if (newresource.modname === TIPDDY_MODULES.page) {
        newresource.tipddyname = TIPDDY_MODULES.page;
      }
      /**schedule
       *
       * @type { PROGRAM }
       * Feedback and handling dates if necesary
       *
       */
      if (newresource.description?.toLowerCase().includes("programa")) {
        newresource.tipddytype = MOODLE_STRINGS.PROGRAMS;
        if (
          newresource.modname === TIPDDY_MODULES.url &&
          getFirstContent(newresource)?.fileurl.includes("vimeo")
        ) {
          newresource.tipddyname = TIPDDY_MODULES.vimeo;

          let vimeodata = getFirstContent(newresource)?.fileurl?.split("/");
          if (vimeodata) {
            newresource.video_id = vimeodata[vimeodata.length - 1];

            if (vimeodata.length > 4) {
              newresource.video_h = vimeodata[vimeodata.length - 1];
              newresource.video_id = vimeodata[vimeodata.length - 2];
            }
          }
        }

        if (
          newresource.modname === TIPDDY_MODULES.resource &&
          hasContents(newresource) &&
          newresource.contents[0].mimetype === MIME_TYPES.pdf
        ) {
          newresource.tipddyname = TIPDDY_MODULES.pdf;
        }

        programModules = [...programModules, newresource];
      }
      /**
       *
       * @type { SCHEDULE }
       * Feedback and handling dates if necesary
       *
       */
      if (
        newresource.description?.toLowerCase().includes(MOODLE_STRINGS.SCHEDULE)
      ) {
        newresource.tipddyname = TIPDDY_MODULES.schedule;
        newresource.tipddytype = TIPDDY_MODULES.schedule;
        newresource.tipddyurl = getFirstContent(newresource)?.fileurl?.split("?")[0] || "";
        newresource.course_id = course_id;
        schedule = [newresource];
      }

      /**
       *
       * @type { FEEDBACK:FINAL }
       * Feedback and handling dates if necesary
       *
       */
      // console.log(newresource);

      if (newresource.description?.toLowerCase().includes("encuesta")) {
        newresource.tipddyname = TIPDDY_MODULES.finalfeedback;
      }

      /**
       *
       * @type { DATE RESTRICTED }
       * Mark modules restricted by date (not hidden, not online)
       *
       */
      const isOnlineModule =
        newresource.modname === TIPDDY_MODULES.url ||
        newresource.modname === TIPDDY_MODULES.zoom;

      if (
        !isOnlineModule &&
        newresource.visible !== 0 &&
        newresource.visibleoncoursepage !== 0 &&
        !newresource.uservisible &&
        newresource.availabilityinfo
      ) {
        newresource.isRestricted = true;
        newresource.restrictedMessage = newresource.availabilityinfo.replace(/<a\b[^>]*>(.*?)<\/a>/gi, "$1");
      }

      console.log(newresource);
    }
  }

  let finalNormalizedModules =
    eliminateProgramAndOnlineAndScheduleModules(normalizeModules);

  let websiteLang = window.location.href.includes("academy.tuclase")
    ? true
    : false;

  if (onlineModules.length < 1) {
    onlineModules = [
      {
        name: websiteLang
          ? "This course course does not have online sessions"
          : "Este curso no posee sesiones en línea",
        tipddytype: "label",
        isTracked: true,
      },
    ];
  }

  return {
    diagnostic,
    modules: finalNormalizedModules,
    online: [
      {
        id: MOODLE_STRINGS.ONLINE,
        name: websiteLang ? "Online Session" : "Sesiones en línea",
        modules: onlineModules,
        uservisible: true,
      },
    ],
    programs: [
      {
        id: MOODLE_STRINGS.PROGRAMS,
        name: websiteLang ? "Programs" : "Programas",
        modules: programModules,
        uservisible: true,
      },
    ],
    schedule,
  };
}

function eliminateProgramAndOnlineAndScheduleModules(modules) {
  let data = modules;
  for (let module of data) {
    let outputmodules = [];

    /** Selection without extra modules */
    for (const resource of module.modules) {
      if (
        resource.tipddytype !== TIPDDY_MODULES.schedule &&
        resource.tipddytype !== MOODLE_STRINGS.PROGRAMS &&
        resource.tipddytype !== MOODLE_STRINGS.ONLINE
      ) {
        outputmodules = [...outputmodules, resource];
      }
    }

    /**
     * Summary module handler
     */
    if (module.summary !== "") {
      outputmodules = [
        {
          id: module.id,
          tipddyname: "summary",
          name: "Resumen",
          summary: module.summary,
          url: module.summary,
          completion: 0,
          isTracked: false,
        },
        ...outputmodules,
      ];
    }

    module.modules = outputmodules;
  }
  return data;
}

export function normalizeCategories({ courses, categories }) {
  /**
   * For each categorie find the courses that matches
   */
  let categoriesNeeded = categories.filter((c) => c.name !== "Cursos");
  for (const category of categoriesNeeded) {
    /**
     * Find the matching courses and pass it to the original category object
     */
    let matchingCourses = categoriesNeeded.filter(
      (c) => c.category === category.id
    );
    /**
     * Setter
     */
    category.courses = matchingCourses;
  }
  /**
   * Returning the final modify original Object
   */
  return categoriesNeeded;
}

function getRawProgress(module) {
  let total = module.modules.filter((task) => task.completiondata).length;
  if (total === 0) {
    module.hasProgress = false;
    return module;
  }

  let completed = module.modules
    .filter((task) => task.completiondata)
    .filter((task) => task.completiondata.state !== 0).length;

  let progressValue = Number((completed * 100) / total);

  module.hasProgress = true;
  module.rawProgress = Number(progressValue.toFixed(0));
  return module;
}

export function getCertificateAndFeedbackFromCourse({ modules }) {
  let feed = null;
  let cert = null;

  for (const module of modules) {
    for (let resource of module.modules) {
      if (resource.tipddyname === TIPDDY_MODULES.finalfeedback) {
        feed = resource;
      }

      if (resource.tipddyname === TIPDDY_MODULES.customcert) {
        cert = resource;
      }
    }
  }

  if (feed) {
    let isCompleted = feed.completiondata.state !== 0;
    if (isCompleted) {
      feed = true;
    } else {
      feed = feed.url;
    }
  }

  if (cert) {
    cert = `${cert.url}&downloadown=1`;
  }

  return {
    feed,
    cert,
  };
}
